import { Link } from "react-router-dom";
import { useAccount } from "../store/account";

export default function PlanNav() {
    const { data: account } = useAccount();

    return account ? (
        <div className="plan-nav">
            {account.offerUpgrade ? (
                <Link to="upgrade" className="button">
                    <span>Upgrade now to</span> Grow Your Show
                </Link>
            ) : null}
        </div>
    ) : null;
}
